import axios from "axios";
import CacheService from "./cache.service";
import CACHEKEYS from "../cacheKeys";
import Constants from "../constants";

const API = `/api/channel`;

const createChannel = async (user, channelname, server) => {
  const chName = channelname.toLowerCase().replace(" ", "");
  try {
    const newchannel = {
      name: chName,
      domain: server,
      created_by: user["id"]
    };
    await axios.post(`${API}`, newchannel);
    CacheService.remove(CACHEKEYS.FETCH_CHANNELS);
    return "success";
  } catch (error) {
    return "failed";
  }
};

const getChannels = async (user) => {
  try {
    const cachkey = CACHEKEYS.FETCH_CHANNELS;
    const cachevalue = CacheService.get(cachkey);
    if (cachevalue !== null) return cachevalue;
    const response = await axios.get(`${API}/${user.id}`);
    const data = response.data.payload || [];
    const servers = [...new Set(data.map((c) => c.domain))];
    servers.sort();
    const dataToCache = {
      data,
      servers,
    };
    CacheService.set(cachkey, dataToCache);
    return dataToCache;
  } catch (error) {
    throw new Error(error.message);
  }
};

const deleteChannel = async (channelid) => {
  try {
    await axios.delete(`${API}/${channelid}`);
    CacheService.remove(CACHEKEYS.FETCH_CHANNELS);
    return true;
  } catch (error) {
    return false;
  }
};

const getChannelDetailsByName = async (channelName) => {
  try {
    const response = await axios.get(`${API}/detail/${channelName}`);
    const data = response.data;
    if (data.status === "success") return data.payload;
    return null;
  } catch (error) {
    return null;
  }
};

const editchannel = async (channel, user) => {
  if (user["type"] === Constants.user_type.SUPER_ADMIN) {
    try {
      await axios.put(`${API}`, channel);
      CacheService.remove(CACHEKEYS.FETCH_CHANNELS);
      return "success";
    } catch (error) {
      return "failed";
    }
  }
  return "failed";
};

const refreshChannel = async (channelName) => {
  try {
    await axios.post(`${API}/refresh/${channelName}`);
    CacheService.remove(CACHEKEYS.FETCH_CHANNELS);
    return "success";
  } catch (error) {
    return "failed";
  }
};

const uploadLogo = async (channelName, logo) => {
  try {
    const formData = new FormData();
    formData.append("logo", logo);
    await axios.put(`${API}/${channelName}/logo`, formData);
    CacheService.remove(CACHEKEYS.FETCH_CHANNELS);
    return "success";
  } catch (error) {
    return "failed";
  }
}

export {
  createChannel,
  getChannels,
  deleteChannel,
  getChannelDetailsByName,
  editchannel,
  refreshChannel,
  uploadLogo
};
